module.exports = __webpack_public_path__ + "img/e323afab426ad7277bd259003de2c9f0.png";